import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';

@Injectable({ providedIn: 'root' })
export class BreeceService {
  constructor(private apiService: ApiService) {}

  testConnection(storeId: string, clientId: string, clientSecret: string): Observable<any> {
    return this.apiService.postRequest(ApiUrl.breeceTestConnection(storeId), { clientId, clientSecret });
  }

  bulkSync(storeId: string): Observable<any> {
    return this.apiService.postRequest(ApiUrl.breeceBulkSync(storeId), {});
  }

  syncProduct(storeId: string, productId: string): Observable<any> {
    return this.apiService.postRequest(ApiUrl.breeceSyncProduct(storeId, productId), {});
  }

  syncSelected(storeId: string, productIds: string[]): Observable<any> {
    return this.apiService.postRequest(`store/${storeId}/breece/sync-selected`, { productIds });
  }

  createSelected(storeId: string, productIds: string[]): Observable<any> {
    return this.apiService.postRequest(`store/${storeId}/breece/create-selected`, { productIds });
  }

  getSyncLogs(storeId: string, page = 1, pageSize = 20): Observable<any> {
    return this.apiService.getRequest(`${ApiUrl.breeceSyncLogs(storeId)}?page=${page}&pageSize=${pageSize}`);
  }

  getSyncLogDetail(storeId: string, logId: string): Observable<any> {
    return this.apiService.getRequest(ApiUrl.breeceSyncLogDetail(storeId, logId));
  }

  updateBreeceConfig(storeId: string, config: { syncIntervalMinutes: number }): Observable<any> {
    return this.apiService.patchRequest(ApiUrl.breecePatchConfig(storeId), config);
  }

  manualBatchSync(storeId: string): Observable<any> {
    return this.apiService.postRequest(ApiUrl.breeceManualBatchSync(storeId), {});
  }
}
